// extracted by mini-css-extract-plugin
module.exports = {"reportCardInfo":"ReportCardInfo_reportCardInfo__35qib","content":"ReportCardInfo_content__7pQmX"};